// If we productize the experiment, we should move this to @mc/share/lib
const getMessageDialogUrl = (body: string) => {
  const encodedBody = encodeURIComponent(body)

  return `sms:&body=${encodedBody}`
}

export default getMessageDialogUrl
